import type { CustomFile } from '../types';

// ----------------------------------------------------------------------------

export type TypeRelativePathData = {
    path: string;
    dirPath?: string;
    rootFolder?: string;
};

// ----------------------------------------------------------------------------

function getRelativePathData(file: CustomFile): TypeRelativePathData | null {
    const relativePath = file.relativePath ?? file.webkitRelativePath;

    if (typeof relativePath !== 'string') {
        return null;
    }

    const path = relativePath.replace(/[\\\/]+/g, '/').trim();

    if (path === '') {
        return null;
    }

    const slashIndex = path.indexOf('/');
    const lastSlashIndex = path.lastIndexOf('/');

    return {
        path,
        rootFolder: slashIndex > 0 ? path.slice(0, slashIndex) : undefined,
        dirPath: lastSlashIndex > 0 ? path.slice(0, lastSlashIndex) : undefined,
    };
}

// ----------------------------------------------------------------------------

export default getRelativePathData;
